import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const HOLIDAYS = {
  '03-01': { name: 'Bosnia & Herzegovina', style: 'bosnia' },
  '03-25': { name: 'Greece', style: 'greece' },
  '05-17': { name: 'Norway', style: 'norway' },
  '05-21': { name: 'Montenegro', style: 'montenegro' },
  '02-24': { name: 'Estonia', style: 'estonia' },
  '05-24': { name: 'Eritrea', style: 'eritrea' },
  '06-22': { name: 'Croatia', style: 'croatia' },
  '06-25': { name: 'Slovenia', style: 'slovenia' },
  '07-04': { name: 'USA', style: 'usa' },
  '07-14': { name: 'France', style: 'france' },
  '07-28': { name: 'Peru', style: 'peru' },
  '08-20': { name: 'Hungary', style: 'hungary' },
  '08-24': { name: 'Ukraine', style: 'ukraine' },
  '09-08': { name: 'Andorra', style: 'andorra' },
  '09-15': { name: 'Central America', style: 'central_america' },
  '09-16': { name: 'Mexico', style: 'mexico' },
  '10-18': { name: 'Azerbaijan', style: 'azerbaijan' },
  '10-28': { name: 'Czech Republic', style: 'czech' },
  '11-11': { name: 'Poland', style: 'poland' },
  '11-18': { name: 'Latvia', style: 'latvia' },
  '12-06': { name: 'Finland', style: 'finland' }
};

export const DynamicLogo = ({ className = 'text-[20px] lg:text-[26px]' }) => {
  const { theme } = useTheme();
  
  const getActiveHoliday = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return HOLIDAYS[`${month}-${day}`];
  };

  const holiday = getActiveHoliday();

  if (holiday) {
    if (holiday.style === 'usa') {
      return (
        <span className={`font-heading font-bold tracking-tight logo-patriotic-glow ${className}`}>
          <span className="logo-union">Ve</span>
          <span className="logo-stripes">onFox</span>
        </span>
      );
    }

    return (
      <span className={`font-heading font-bold tracking-tight logo-holiday-glow logo-${holiday.style} ${className}`}>
        VeonFox
      </span>
    );
  }

  // Default logo style (clean silver/white text or adapts to dark/light theme)
  return (
    <span className={`font-heading font-bold tracking-tight logo-default ${className}`}>
      VeonFox
    </span>
  );
};

export default DynamicLogo;
